import React, { useState } from "react"; // اضافه شدن useState
import { Link, Outlet } from "react-router-dom";
import { useAuth } from "../Auth/AuthContext";
import "../../css/Dashboard.css";

const Dashboard = () => {
  return (
        <Outlet /> 
  );
};

export default Dashboard;
